angular
    .module('claimVic.controller')
    .controller('reviewClaimDetailsController', ['$rootScope', '$scope', '$window', '$timeout', '$route', 'popupService', 'uploadFileWording', 'httpService', 'claimSumm', 'claimReviewWording',
        function ($rootScope, $scope, $window, $timeout, $route, popupService, uploadFileWording, httpService, claimSumm, claimReviewWording) {
            var maxNumberOfFiles = 10;
            UploadFileExtension($scope, {
                // $form: document.querySelector('#fileupload'),
                submitText: 'Uploading ...',
                fnSubmitFile: fnSubmitFile,
                fnFileUploadStop: fnFileUploadStop,
                maxNumberOfFiles: maxNumberOfFiles
            }, uploadFileWording, $window, httpService);
            $scope.baseUploadPath = 'uploads';

            $scope.pageForms = {};
            $scope.formData = {
                uploadSession: $scope.generateUploadSession(),
                ClaimId: $rootScope.pageNavigationHistory.claim.ClaimId,
                employer: {
                    LiableCostCenter: null,
                    PayrollCostCenter: null
                },
                employee: {
                    CeaseDateAvailable: true
                },
                
            };

            $scope.init = function () {
                // Wizard Initialization
                $('.wizard-card').bootstrapWizard({
                    'tabClass': 'nav nav-pills',
                    'nextSelector': '.btn-next',
                    'previousSelector': '.btn-previous',

                    onNext: function (tab, navigation, index) {

                    },

                    onInit: function (tab, navigation, index) {

                    },

                    onTabClick: function (tab, navigation, index) {
                        if(index === 0) {
                            return !$scope.currentTabInvalid();
                        }
                        return true;
                    },

                    onTabShow: function (tab, navigation, index) {
                        $scope.currentTabIndex = index;
                        $timeout(function() {
                            $scope.$digest();
                        });

                        var $total = navigation.find('li').length;
                        var $current = index + 1;

                        var $wizard = navigation.closest('.wizard-card');

                        // If it's the last tab then hide the last button and show the finish instead
                        if ($current >= $total) {
                            $($wizard).find('.btn-next').hide();
                            $($wizard).find('.btn-finish').show();
                        } else {
                            $($wizard).find('.btn-next').show();
                            $($wizard).find('.btn-finish').hide();
                        }
                    }
                });

                titleEmployerName = '<p>Selecting the wrong Directorate may cause delays processing your claim.</p>';
                $('[data-target="employerName"][data-toggle="tooltip"]').tooltip({
                    container: 'body',
                    html: true,
                    title: titleEmployerName,
                    template: '<div class="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner max-width-tooltip"></div></div>',
                    triggers: 'click hover focus'
                });
            }

            $scope.changeCeaseDate = function() {
                $scope.formData.employee.CeaseDate = null;
            }

            $scope.currentTabInvalid = function() {
                if($scope.currentTabIndex === 0) {
                    return $scope.employerFormInvalid();
                } else {
                    return $scope.employeeFormInvalid();
                }
            }

            $scope.employerFormInvalid = function() {
                return ($scope.pageForms.claimReviewForm.EmployerGroupId && $scope.pageForms.claimReviewForm.EmployerGroupId.$invalid)
                    || $scope.pageForms.claimReviewForm.EmployerContactName.$invalid
                    || $scope.pageForms.claimReviewForm.EmployerPositionTitle.$invalid
                    || $scope.pageForms.claimReviewForm.EmployerContactAddress.$invalid
                    || $scope.pageForms.claimReviewForm.EmployerContactSuburb.$invalid
                    || $scope.pageForms.claimReviewForm.EmployerContactState.$invalid
                    || $scope.pageForms.claimReviewForm.EmployerContactPostCode.$invalid
                    || $scope.pageForms.claimReviewForm.EmployerContactNumber.$invalid
                    || $scope.pageForms.claimReviewForm.EmployerContactEmail.$invalid
                    || $scope.pageForms.claimReviewForm.CaseManagerName.$invalid
                    || $scope.pageForms.claimReviewForm.CaseManagerAddress.$invalid
                    || $scope.pageForms.claimReviewForm.CaseManagerSuburb.$invalid
                    || $scope.pageForms.claimReviewForm.CaseManagerState.$invalid
                    || $scope.pageForms.claimReviewForm.CaseManagerPostCode.$invalid
                    || $scope.pageForms.claimReviewForm.CaseManagerNumber.$invalid
                    || $scope.pageForms.claimReviewForm.CaseManagerEmail.$invalid
                    || $scope.pageForms.claimReviewForm.LiableCostCenter.$invalid
                    || $scope.pageForms.claimReviewForm.PayrollCostCenter.$invalid
                    || $scope.pageForms.claimReviewForm.ProvideStatementOfFact.$invalid;
            }

            $scope.employeeFormInvalid = function() {
                return $scope.pageForms.claimReviewForm.EmployeeAGS.$invalid
                    || $scope.pageForms.claimReviewForm.EmployerNotifiedDate.$invalid
                    || $scope.pageForms.claimReviewForm.EmployerNotifiedTime.$invalid
                    || $scope.pageForms.claimReviewForm.EmploymentType.$invalid
                    || $scope.pageForms.claimReviewForm.CommencementEmploymentDate.$invalid
                    || $scope.pageForms.claimReviewForm.CommencementEmploymentTime.$invalid
                    || $scope.pageForms.claimReviewForm.StandardWeeklyWorkHour.$invalid
                    || $scope.pageForms.claimReviewForm.EmployeeJobTitle.$invalid
                    || $scope.pageForms.claimReviewForm.EmployeeMainDuties.$invalid
                    || $scope.pageForms.claimReviewForm.EmployeeType.$invalid
                    || $scope.pageForms.claimReviewForm.IsOffWork.$invalid
                    || $scope.pageForms.claimReviewForm.CeaseDateAvailable.$invalid
                    || $scope.pageForms.claimReviewForm.UserCompleteFormName.$invalid;
            }

            function fnSubmitFile() {
                $scope.uploadResult.hasError = false;
                $scope.uploadControl.isProcessing = true;
                $scope.uploadControl.allowAddFile = false;
                $scope.uploadControl.allowSubmit = false;
                $scope.uploadControl.submitText = 'Uploading...';
            } // fnSubmitFile

            function fnFileUploadStop(e) {
                if ($scope.uploadResult.hasError) {
                    var uploadError = $scope.getFileUploadError();
                    popupService.showValidationServerErrors(uploadError, undefined, reload);

                } else {
                    $scope.submitClaimReview();
                }
            }; // fnFileUploadStop

            $scope.removeFile = function (file, queue) {
                event.stopPropagation();
                event.preventDefault();
                file.$cancel();
                if (queue.length == 0) {
                    $scope.clearError();
                }
                $scope.deleteFileUpload(file);
            } // removeFile

            $scope.aClicked = false;
            $scope.selectFiles = function (f) {
                $timeout(function () {
                    if (!$scope.aClicked) {
                        angular.element(f).trigger('click');
                    }
                    $scope.aClicked = false;
                }, 100);

            } // selectFiles
            $('body').on('click', '.upload-file', function () {
                $scope.aClicked = true;
            })

            $scope.submitReview = function() {
                if ($scope.fileData && $scope.fileData.scope.queue.length > 0) {
                    $scope.submitFile(this);
                } else {
                    $scope.submitClaimReview();
                }
            }

            $scope.submitClaimReview = function() {
                claimSumm.submitClaimReview($scope.formData).then(function (data) {
                    if (data.Success === true) {
                        popupService.showText(claimReviewWording.REVIEW_CLAIM_SUCCESS, undefined, function () {
                            popupService.hide();
                            $route.reload();
                        });
                    } else {
                        popupService.showError(data.ErrorMessage);
                        $route.reload();
                    }
                }, function (err) {
                    popupService.showError('An unknown error occurred.');
                });
            }

            $scope.closeClaimReview = function() {
                claimSumm.cancelBlockClaimReview($scope.formData.ClaimId);
                popupService.hide();
            }
    }]);
